import { createSelector } from 'reselect';

const getOwnUserId = (state) => state.user.id;

/**
 * state.experts.idsToExperts
 */
const getIdsToExperts = (state) => state.experts.idsToExperts;

export const getOwnExpert = createSelector(
  [getOwnUserId, getIdsToExperts],
  (userId, idsToExperts) => idsToExperts[userId]
);

export const getOwnAvailability = createSelector([getOwnExpert], (expert) => expert && expert.availability);
